import React, { ComponentProps, CSSProperties, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { sanitizeInternalUrl } from 'lib/redirect';

import { commonLinkStyle, CommonLinkProps } from './common.style';

const StyledLink = styled(Link)<CommonLinkProps>`
  ${commonLinkStyle}
`;

type Props = Omit<CommonLinkProps, '$underline'> & {
  children?: ReactNode;
  to: ComponentProps<typeof Link>['to'];
  style?: CSSProperties;
  className?: string;
  onClick?: () => void;
  title?: string;
  underline?: boolean;
};

function RouterLink({
  to,
  children,
  style,
  className,
  title,
  color = 'light',
  underline,
  onClick,
  disabled,
}: Props) {
  return (
    <StyledLink
      onClick={disabled ? event => event.preventDefault() : onClick}
      color={color}
      // We want only allow internal routing for links
      to={typeof to === 'string' ? sanitizeInternalUrl(to) : to}
      style={style}
      className={className}
      $underline={underline}
      title={title}
      disabled={disabled}
    >
      {children}
    </StyledLink>
  );
}

export default RouterLink;
